export const deviceTypeDict = {
  "4": "Hale SEI-03",
  "9": "Hale MCT07"
};
